import { gql } from '@apollo/client';
import { ReportSectionState } from '@mnd-frontend/graphql-schema';
import { GREY_900 } from '@mnd-frontend/ui/shared/tokens';
import type { Report2PerceptionSentimentOverTimeFragment } from '../../../../../generated/types';
import { SentimentAnalysisGraph } from '../../charts';
import { Insights, Section, SectionHeader } from '../../common';

export const REPORT2_PERCEPTION_SENTIMENT_OVER_TIME_FRAGMENT = gql`
  fragment Report2PerceptionSentimentOverTime on ReportPerceptionSentimentOverTime {
    id
    title
    state
    groupBy
    sentimentAnalysis {
      startAt
      endAt
      week
      month
      positive
      negative
    }
    insights2 {
      id
      title
      insight
      insightType
    }
  }
`;

const PerceptionSentimentOverTime = ({
  section,
}: {
  section: Report2PerceptionSentimentOverTimeFragment;
}) => {
  const { insights2 } = section;

  return (
    <Section>
      <SectionHeader
        color={GREY_900}
        as="h3"
        variant="reportHeadlineLarge"
        section={section}
        isSubsection
      />
      <SentimentAnalysisGraph
        loading={section.state !== ReportSectionState.Done}
        sentimentAnalysis={section.sentimentAnalysis}
        groupBy={section.groupBy}
      />
      <Insights insights={insights2} />
    </Section>
  );
};

export default PerceptionSentimentOverTime;
